module.exports = __webpack_public_path__ + "static/media/bgDefaultCoursesNight.b82ed8c1.jpg";